import { View, StyleSheet, Text } from '@react-pdf/renderer';
import React from 'react';
import dayjs from 'libs/dayjs';

// Función para formatear el RUT correctamente
const formatRUT = (rut) => {
  if (!rut) return '';

  // Si ya tiene formato, lo devolvemos tal como está
  if (rut.includes('-')) {
    return rut;
  }

  // Si no tiene formato, intentamos formatearlo
  const cleanRUT = rut.replace(/[^0-9kK]/g, '');
  if (cleanRUT.length < 2) return rut;

  // Separamos el número del dígito verificador
  const number = cleanRUT.slice(0, -1);
  const dv = cleanRUT.slice(-1).toUpperCase();

  // Formateamos con puntos y guión
  const formattedNumber = number.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  return `${formattedNumber}-${dv}`;
};

const styles = StyleSheet.create({
  title: {
    fontFamily: 'Helvetica-Bold',
    fontSize: '14px',
    color: '#2c3e50',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: '0.8cm',
    paddingBottom: '0.3cm',
    borderBottom: '2px solid #548235',
  },
  dataGrid: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.3cm',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: '#f8f9fa',
    borderRadius: '0.2cm',
    overflow: 'hidden',
    border: '1px solid #e8e8e8',
  },
  cellHeader: {
    flex: 1,
    backgroundColor: '#548235',
    padding: '0.4cm 0.3cm',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  cellHeaderText: {
    fontFamily: 'Helvetica-Bold',
    fontSize: '10px',
    color: '#ffffff',
    textTransform: 'uppercase',
    letterSpacing: '0.3px',
  },
  cellContent: {
    flex: 2,
    padding: '0.4cm 0.3cm',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    backgroundColor: '#ffffff',
    minWidth: '6cm',
  },
  cellContentText: {
    fontSize: '11px',
    color: '#34495e',
    fontFamily: 'Helvetica',
  },
  rutText: {
    fontSize: '11px',
    color: '#34495e',
    fontFamily: 'Helvetica',
    letterSpacing: '0.5px',
  },
});

function BudgetDataClient(props) {
  const { budget } = props;
  const { name, rut, phone, address, commune, email, contactName, createdOn } =
    budget;
  return (
    <View>
      <Text style={styles.title}>1. Datos del Cliente</Text>
      <View style={styles.dataGrid}>
        <View style={styles.row}>
          <View style={styles.cellHeader}>
            <Text style={styles.cellHeaderText}>Razón Social</Text>
          </View>
          <View style={styles.cellContent}>
            <Text style={styles.cellContentText}>{name}</Text>
          </View>
        </View>
        <View style={styles.row}>
          <View style={styles.cellHeader}>
            <Text style={styles.cellHeaderText}>RUT</Text>
          </View>
          <View style={styles.cellContent}>
            <Text style={styles.rutText}>
              {/* No eliminar el {} porque si se elimina no aparece el digito verificador */}
              {formatRUT(rut)} {}
            </Text>
          </View>
        </View>
        <View style={styles.row}>
          <View style={styles.cellHeader}>
            <Text style={styles.cellHeaderText}>Dirección</Text>
          </View>
          <View style={styles.cellContent}>
            <Text style={styles.cellContentText}>{address}</Text>
          </View>
        </View>
        <View style={styles.row}>
          <View style={styles.cellHeader}>
            <Text style={styles.cellHeaderText}>Comuna</Text>
          </View>
          <View style={styles.cellContent}>
            <Text style={styles.cellContentText}>{commune}</Text>
          </View>
        </View>
        <View style={styles.row}>
          <View style={styles.cellHeader}>
            <Text style={styles.cellHeaderText}>Teléfono</Text>
          </View>
          <View style={styles.cellContent}>
            <Text style={styles.cellContentText}>{phone}</Text>
          </View>
        </View>
        <View style={styles.row}>
          <View style={styles.cellHeader}>
            <Text style={styles.cellHeaderText}>Correo Electrónico</Text>
          </View>
          <View style={styles.cellContent}>
            <Text style={styles.cellContentText}>{email}</Text>
          </View>
        </View>
        <View style={styles.row}>
          <View style={styles.cellHeader}>
            <Text style={styles.cellHeaderText}>Persona de Contacto</Text>
          </View>
          <View style={styles.cellContent}>
            <Text style={styles.cellContentText}>{contactName}</Text>
          </View>
        </View>
        <View style={styles.row}>
          <View style={styles.cellHeader}>
            <Text style={styles.cellHeaderText}>Fecha de Emisión</Text>
          </View>
          <View style={styles.cellContent}>
            <Text style={styles.cellContentText}>
              {dayjs(createdOn).format('L')}
            </Text>
          </View>
        </View>
      </View>
    </View>
  );
}





export default BudgetDataClient;
